import React, { useState, useEffect } from "react";
import {
  Box,
  Switch,
  Typography,
  Button,
  TextField,
  Modal,
  Paper,
  IconButton,
  useMediaQuery, useTheme
} from "@mui/material";

import { Close } from "@mui/icons-material";
import Banner from '../../../src/assets/GiftAsset/banner.svg';

const PromotionAvailability = ({ handleNext, handleBack, formData, setFormData }) => {
  const [openModal, setOpenModal] = useState(false);
  const [isPromotionIncluded, setIsPromotionIncluded] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const handleToggle = () => {
    setFormData((prev) => ({
      ...prev,
      promotion: { ...prev.promotion, enabled: !prev.promotion?.enabled || false },
    }));
  };

  useEffect(() => {
    setIsPromotionIncluded(formData?.promotion?.enabled || false);
  }, [formData.promotion?.enabled]);

  useEffect(() => {
    const promotionDays = formData.promotion?.days || 0;
    const availabilityCost = formData.availability?.cost || 0;
    const promotionCost = formData.promotion?.enabled ? promotionDays * 500 : 0;
  
    setTotalAmount(availabilityCost + promotionCost);
  }, [
    formData.availability?.cost,  // ✅ Add this missing dependency
    formData.availability?.noOfDays,
    formData.promotion?.days,
    formData.promotion?.enabled
  ]);
  

  const handleConfirm = () => {
    setIsPromotionIncluded(formData?.promotion?.enabled);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };


  return (
    <Box sx={{ p: 3, maxWidth: 500, mx: "auto" }}>

<Box sx={{ borderBottom: "1px solid #ddd", pb: 2 }}>
  <Typography variant="h4" align="center" color="#5604F6" fontWeight={600}>
  Set Product Availability
  </Typography>

  
 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
              <Box sx={{ p: 1,  bgcolor: "#eee", borderRadius: 2, display: "inline-block" }}>
                               <Typography variant="caption" color="#5604F6" fontWeight={500}  sx={{ fontSize: isDesktop ? 18 : 20 }} >
                                 Instructions
                               </Typography>  
                             </Box>
               <Typography variant="body2" sx={{ color: "gray",  textAlign: "justify" ,  fontSize: isDesktop ? 18  : 20 }} >
                Specify how long the product will be available. Each day costs ₦100.
                </Typography>
              </Box> 




      
<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 8 }}>
   <Typography   fontSize="18px"
         sx={{ ...theme.typography.urbanist800,color: "#000000" }}>
    How many days do you want the product to be available?
  </Typography>
 
</Box>

<TextField
          type="number"
          value={formData.availability?.noOfDays || ""}
          onChange={(e) => {
            const days = Number(e.target.value) || 0;
            setFormData({
              ...formData,
              availability: {
                ...formData.availability,
                noOfDays: days,
                cost: days * 100,
              },
            });
          }}
          sx={{
            mt: 2,
            width: "100%",
            "& input": {
              border: "1px solid gray",
              borderRadius: "12px",
              padding: "10px",
            },
          }}
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Typography variant="body2" sx={{ color: "#5604F6" }}>
          ₦{(formData.availability?.cost || 0).toLocaleString()} for {formData.availability?.noOfDays || 0} days.

          </Typography>
        </Box>

       
<Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mt: 2 }}>
<Typography>
  {formData.promotion.enabled
    ? "Yes, I Want To Promote This Product"
    : "Do You Want To Promote This Product?"}
</Typography>

  <Switch
    checked={formData.promotion.enabled}
    onChange={handleToggle}
  
    sx={{
      "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#5604F6",
      },
      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#5604F6",
      },
    }}
  />
</Box>


{formData.promotion.enabled && (
  <Box sx={{ mt: 8 }}>
    <Typography variant="h4" align="center" color="#5604F6" fontWeight={600}>
      Promote Your Product
    </Typography>


          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pb: "14px", borderBottom: "2px solid #ddd",  }}>
                <Box sx={{ p: 1,  bgcolor: "#eee", borderRadius: 2, display: "inline-block" }}>
                                            <Typography variant="caption" color="#5604F6" fontWeight={500}  sx={{ fontSize: isDesktop ? 18 : 20 }} >
                                              Instructions
                                            </Typography>  
                                          </Box>
               <Typography variant="body2" sx={{ color: "gray",  textAlign: "justify" ,  fontSize: isDesktop ? 18  : 20 }} >
                Specify how long the product will be on promotion. Each day costs ₦500.
                </Typography>
              </Box> 
        


          <Box sx={{ mt: 5 }}>
    <Typography   fontSize="18px"
          sx={{ ...theme.typography.urbanist800,color: "#000000", mb:"10px" }}>
    Select Promotion Duration
  </Typography>
  <TextField
            type="number"
            value={formData.promotion?.days || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                promotion: {
                  ...formData.promotion,
                  days: Number(e.target.value) || 0,
                },
      })
    }
    sx={{
      width:"100%",
      height:"40px",
      mb:"12px",
      "& .MuiOutlinedInput-root": {
        borderRadius: "12px",
        backgroundColor: "#fff",
       
        fontSize: isDesktop ? 18 : 16
      },
      "& .MuiInputBase-input::placeholder": {
        color: "#A0A0A0",
     
            fontSize: isDesktop ? 14 : 18
      },
    }}
          />
</Box>

<Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
<Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
<Typography variant="body2" sx={{ color: "#5604F6" }}>
₦{((formData.promotion?.days || 0) * 500).toLocaleString()} for {formData.promotion?.days || 0} days.

</Typography>

          </Box>
   </Box>       
        </Box>
      )}
 <Box sx={{ display: "flex", justifyContent:"center", flexDirection: isDesktop ? "row" : "column", mt: 3, width: "100%", gap: 2 }}>
  <Button
    variant="contained"
    sx={{
      mt: 3,
      width: isDesktop ? "40%" : "100%",
      borderRadius: "999px",
      backgroundColor: "#EEE6FE !important",
            color: "#5604F6 !important",
            fontSize: isDesktop ? "16px" : "18px",
      textTransform: "none",
      "&:hover": { backgroundColor: "#B0B0B0" }
    }}
    onClick={handleBack}
  >
    {"< Back to step 3"}
  </Button>
  
  <Button
    variant="contained"
    sx={{
      mt: 3,
      width: isDesktop ? "40%" : "100%",
      borderRadius: "999px",
      backgroundColor: "#5604F6 !important",
      fontSize: isDesktop ? "16px" : "18px",
            color: "#EEE6FE !important",
      textTransform: "none",
      "&:hover": { backgroundColor: "#4b00c2" },
    }}
    onClick={handleConfirm}
  >
    Next →
  </Button>
</Box>


<Modal open={openModal} onClose={handleClose}>
      <Paper sx={{ p: 3, maxWidth: 500, mx: "auto", mt: 10, position: "relative", borderRadius: 3 }}>
        {/* Close Icon */}
        <IconButton 
          onClick={handleClose} 
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <Close />
        </IconButton>

        {/* Promotion Icon */}
        <Box display="flex" justifyContent="center" mb={2}>
         <img
                   src={Banner}
                   alt="Promotion"
                   style={{ width: "20%", height: "auto", }}
                 />
        </Box>

        {/* Title */}
        <Typography   fontSize="24px" textAlign="center"
         sx={{ ...theme.typography.urbanist800,color: "#000000" }}>
          {isPromotionIncluded ? "Confirm Promotion & Availability Cost" : "Confirm Availability Cost"}
        </Typography>

        {/* Description */}
        <Typography   fontSize="18px" textAlign="center"
         sx={{ ...theme.typography.urbanist800,color: "#000000", mt:"2px" }}>
          Your product will be live for <strong>{formData.availability?.noOfDays || 0}</strong> days at ₦{formData.availability?.noOfDays * 100}.<br />
          {isPromotionIncluded &&
            <>
              It will also be promoted for <strong>{formData.promotion?.days || 0}</strong> days at ₦{formData.promotion?.days * 500}.
            </>
          }
          <br /><br />
          <strong>Total Cost: ₦{totalAmount}</strong>
        </Typography>

        {/* Buttons */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3, width: "100%" }}>
          <Button
            variant="contained"
            sx={{
              width: "50%",
              borderRadius: "999px",
              backgroundColor: "#6200ea !important",
              color: "#fff !important",
              textTransform: "none",
              fontSize: isDesktop ? "16px" : "18px",
              "&:hover": { backgroundColor: "#4b00c2" },
            }}
            onClick={handleNext}
          >
            Yes, Proceed
          </Button>
        </Box>
      </Paper>
    </Modal>
    </Box>
    </Box>
  );
};

export default PromotionAvailability;
